import { TOUR_IDS, type TourId } from './types';

const TOUR_ROUTE_PATTERNS: Record<TourId, RegExp> = {
  [TOUR_IDS.ORGANIZATIONS_LIST]: /^\/organizations\/?$/,
  [TOUR_IDS.CREATE_ORGANIZATION]: /^\/organizations\/create\/?$/,
  [TOUR_IDS.ORGANIZATION_DETAIL]: /^\/organization\/[^/]+\/?$/,
  [TOUR_IDS.CREATE_TOURNAMENT]:
    /^\/organization\/[^/]+\/tournaments\/create\/?$/,
  [TOUR_IDS.TOURNAMENT_STRUCTURE]: /^\/tournament\/[^/]+\/structure\/?$/,
  [TOUR_IDS.ENTRY_FEE_PRIZE]: /^\/tournament\/[^/]+\/entry-fee-prize\/?$/,
  [TOUR_IDS.WALLET]: /^\/wallet\/?$/,
};

export const isTourRouteMatch = (tourId: TourId, pathname: string): boolean =>
  TOUR_ROUTE_PATTERNS[tourId].test(pathname);
